// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fbb14fb2","453":"639001b4","455":"3560bfea","977":"a17253fd"}[chunkId] + ".chunk.js";
};